import React, { useEffect } from 'react'
import { Select, Autocomplete, AutocompleteItem, SelectItem } from '@ui-kitten/components'
import { View, Dimensions } from 'react-native'
import { useTranslation } from 'react-i18next'

export default function PlatformDependantSelect ({ data, selectedOption, onSelect, style, disabled, withSearch=false, autoClear=false, titleKey='text', ...otherProps }) {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(selectedOption?.text)
  const [internalData, setInternalData] = React.useState(data)
  const onChangeText = (query) => {
    setValue(query)
    setInternalData(data.filter(item => item.text.toLowerCase().includes(query.toLowerCase())))
  }
  const _ref = React.useRef(null)
  const _viewRef = React.useRef(null)

  const entryToAutocompleteItem = (entry) => {
    return (<AutocompleteItem title={entry[titleKey]} key={entry[titleKey]} />)
  }
  const entryToSelectItem = (entry) => {
    return (<SelectItem title={entry[titleKey]} key={entry[titleKey]} />)
  }

  useEffect(() => {
    setInternalData(data)
    setValue(selectedOption?.text)
  }, [data, selectedOption])

  if (withSearch) {
    return ( // wraped with View to fix the error with Autocomplete width on web
      <View ref={_viewRef} style={{alignSelf: 'stretch'}}> 
        <Autocomplete
          ref={_ref}
          value={value}
          onChangeText={onChangeText}
          placeholder={t('select')}
          onSelect={(index) => {
            let option = internalData[index]
            onSelect(option)
            if (autoClear) {
              setValue('')
            } else {
              setValue(option[titleKey])
            }
            _ref.current.blur()
            setInternalData(data)
          }}
          style={[{width: (_viewRef.current?.offsetWidth || (Dimensions.get('window').width-50))}, style]}
          disabled={disabled}
          // placement='top'
          {...otherProps}
        >
          {internalData?.map(entryToAutocompleteItem)}
        </Autocomplete>
      </View>
    )
  } else {
    return (
      <Select
        value={value}
        onSelect={(index) => {
          let option = internalData[index.row]
          onSelect(option)
          setValue(option[titleKey])
        }}
        placeholder={t('select')}
        style={style}
        disabled={disabled}
        {...otherProps}
      >
        {internalData?.map(entryToSelectItem)}
      </Select>
    )
  }
}
